import isUndefined from "lodash/isUndefined";
import isNull from "lodash/isNull";

import {
  getEmployees,
  getEmployeeById,
  updateEmployeeStatus,
  removeEmployee,
} from "../repositories/employeeRepository";

const employeeService = {
  getEmployees: async ({ currentPage, pageSize, search }) => {
    const pageNumber =
      isUndefined(currentPage) || isNull(currentPage) ? 1 : currentPage;
    const itemsPerPage =
      isUndefined(pageSize) || isNull(pageSize) ? 20 : pageSize;

    const params = {
      "current-page": pageNumber,
      "page-size": itemsPerPage,
    };
    if (search?.trim()) params.search = search.trim();
    return await getEmployees(params);
  },

  getEmployeeById: async (id) => await getEmployeeById(id),

  updateEmployeeStatus: async (status, body) =>
    await updateEmployeeStatus(status, body),

  removeEmployee: async (id) => await removeEmployee(id),
};

export default employeeService;
